export const naturalSort = (array, prop) => {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  return array.sort((a, b) => {
    const aProp = a[prop];
    const bProp = b[prop];

    if (aProp === bProp) {
      return 0;
    }
    if (aProp === null) {
      return 1;
    }
    if (bProp === null) {
      return -1;
    }

    return collator.compare(aProp, bProp);
  });
};

export default naturalSort;
